import { render, staticRenderFns } from "./PowerSwitchPannel.vue?vue&type=template&id=198c48de&scoped=true&"
import script from "./PowerSwitchPannel.vue?vue&type=script&lang=js&"
export * from "./PowerSwitchPannel.vue?vue&type=script&lang=js&"
import style0 from "./PowerSwitchPannel.vue?vue&type=style&index=0&id=198c48de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c48de",
  null
  
)

export default component.exports